<template>
  <div>
    <div style="padding-top: 40px">
      <div>
        <p class="navadno-besedilo">
          SMS pošiljatelj je preprosto orodje za pošiljanje sporočil direktno iz aplikacije Moj T-2.
          <span v-if="formaOrientacija === 'left'">
            <br>
          </span>
          Najbolj uporaben je za vse, ki želite poslati SMS sporočila več prejemnikom hkrati.
        </p>
      </div>
      <div style="padding-top: 30px">
        <p class="open-sans-20pt">
          Sporočilo
        </p>
      </div>
      <div style="padding-top: 10px">
        <el-form label-width="100px" :label-position="formaOrientacija" class="nova-vrstica-forma">
          <el-form-item label="Pošiljatelj">
            <el-select v-if="listaPosiljatelji" v-model="posiljateljMsisdn" no-data-text="Nimate tel. St"
                       v-loading="loading" class="velikost-input-posiljatelj"
                       placeholder="Izberite tel. številko" @change="UpdateIzbranPosiljatelj">
              <el-option
                v-for="(posiljatelj, key) in listaPosiljatelji"
                :value="posiljatelj.telefonska_stevilka"
                :label="VrniFormatiranoTelefonsko(posiljatelj.telefonska_stevilka, posiljatelj.tip_stevilke)"
                :key="key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Prejemnik">
            <el-select class="lista-zacetnih-st" v-model="zacetnaStDodajPrejemnika"
                       :placeholder="listaZacetnihSt[0]">
              <el-option
                v-for="st in listaZacetnihSt"
                :value="st"
                :label="st"
                :key="st">
              </el-option>
            </el-select>
            <el-input class="tel-st-vnosno-polje" placeholder="Telefonska številka" :maxlength="6"
                      v-model="drugiDelStDodajPrejemnika">
            </el-input>
            <a @click="PreveriDodajPrejemnikaStevilka" class="dodaj-prejemnika">
              <b>
                + DODAJ PREJEMNIKA
              </b>
            </a>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div>
      <div class="flex-container">
        <div class="flex-child magenta">
          <el-input v-model="vnesenTextSmsa" type="textarea"
                    id="sms-text" resize="none" class="vnostno-polje-sporocilo" :maxlength="480" :rows="5"
                    show-word-limit placeholder="Vnesite sporočilo">
          </el-input>
        </div>
        <div style="" class="flex-child green" v-if="selectedContacts.length > 0">
          <div class="postavitev-gumba-poslji-sms">
            <el-button class="gumb-potrdi" @click="PosljiSporocilo">
              POŠLJI SMS
            </el-button>
          </div>
        </div>
      </div>
      <div style="padding-top: 40px" v-if="selectedContacts.length > 0">
        <b>
          <p class="open-sans-17pt">
            Seznam prejemnikov:
            <span class="primarna-barva">
            {{selectedContacts.length}}
          </span>
          </p>
        </b>
        <div>
          <el-table
            :data="seznamPodatkov">
            <el-table-column
              property="ime"
              label="Ime">
            </el-table-column>
            <el-table-column
              property="priimek"
              label="Priimek">
            </el-table-column>
            <el-table-column
              property="mobile"
              label="Telefonska številka">
            </el-table-column>
            <el-table-column
              property="group"
              label="Skupina">
            </el-table-column>
            <el-table-column align="right">
              <template slot-scope="scope">
                <a @click="OdstraniKontaktIzImenika(scope.row)" style="cursor: pointer">
                  <img src="/static/img/Nastavitve/SpletnaPredstavitev\Icon-awesome-trash-alt.png">
                </a>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="text-center" style="cursor: pointer; padding-top: 20px">
          <el-pagination
            :hide-on-single-page="true"
            @current-change="PrikaziStran"
            :page-size="10"
            layout="prev, pager, next"
            :total="dolzinaKontaktov"
            small>
          </el-pagination>
        </div>
      </div>
      <div>
        <InfoKomponentaPosiljanjeSms :maxSteviloPrejemnikov="smsLimit"/>
      </div>
    </div>
  </div>
</template>
<script>
import {Select, Option, Table, Button, Input, Tooltip, Collapse, CollapseItem, MessageBox, Pagination} from 'element-ui'
import InfoKomponentaPosiljanjeSms from './InfoKomponentaPosiljanjeSms'
import {SirinaOkna} from '../../../../../assets/js/globalne_funkcije/SirinaOkna'
import {FormatirajTelefonskoStevilko}
  from '../../../../../assets/js/globalne_funkcije/GlobalnoTelefonija/FormatTelefonskeStevilke.js'
import Vue from 'vue'
Vue.use(Pagination)
export default {
  name: 'PosljiSmsVmesnik',
  mixins: [SirinaOkna, FormatirajTelefonskoStevilko],
  data () {
    return {
      seznamPrejemnikov: [],
      vnesenTextSmsa: null,
      zacetnaStDodajPrejemnika: '064',
      drugiDelStDodajPrejemnika: null,
      idPrikljucek: null,
      loading: false,
      stZnakovLeft: 480,
      mejnaSirina: 1400,
      formaOrientacija: 'left',
      seznamKontaktov: [],
      posiljateljMsisdn: null,
      posiljateljObject: null,
      dolzinaKontaktov: 0,
      seznamPodatkov: [],
      kontakti: [],
      seznamDokumentov: []
    }
  },
  components: {
    InfoKomponentaPosiljanjeSms,
    [Button.name]: Button,
    [Select.name]: Select,
    [Table.name]: Table,
    [Option.name]: Option,
    [Input.name]: Input,
    [Tooltip.name]: Tooltip,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Pagination.name]: Pagination
  },
  props: {
    listaZacetnihSt: null,
    selectedContacts: null,
    vsiKontakti: null,
    listaPosiljatelji: null,
    izbranPosiljatelj: null,
    smsAuthentication: false,
    clientAgent: null,
    smsLimit: null
  },
  watch: {
    vnesenTextSmsa: function (val) {
      this.vnesenTextSmsa = val.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      this.vnesenTextSmsa = this.vnesenTextSmsa.replace('đ', 'd')
      this.vnesenTextSmsa = this.vnesenTextSmsa.replace('Đ', 'D')
      this.stZnakovLeft = 480 - this.vnesenTextSmsa.length
    },
    izbranPosiljatelj: {
      immediate: true,
      deep: true,
      handler (val) {
        if (val !== null && typeof val.telefonska_stevilka !== 'undefined' &&
          val.telefonska_stevilka !== this.posiljateljMsisdn) {
          this.posiljateljMsisdn = ''
          this.posiljateljMsisdn = val.telefonska_stevilka
        }
      }
    },
    selectedContacts: {
      immediate: true,
      deep: true,
      handler (val) {
        if (val) {
          this.kontakti = val
          this.Pegination()
        }
      }
    }
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    Pegination () {
      if (typeof this.kontakti !== 'undefined') {
        let tmpArray = []
        this.dolzinaKontaktov = this.kontakti.length
        const chunk = 10
        for (let i = 0; i < this.dolzinaKontaktov; i += chunk) {
          tmpArray.push(this.kontakti.slice(i, i + chunk))
        }
        this.kontakti = tmpArray
        this.PrikaziStran(1)
      }
    },
    PrikaziStran (stran) {
      if (typeof this.kontakti[stran - 1] !== 'undefined') {
        this.seznamPodatkov = this.kontakti[stran - 1]
      } else {
        this.seznamPodatkov = []
      }
    },
    OdstraniKontaktIzImenika (contact) {
      MessageBox.confirm('Ali ste prepričani, da želite odstraniti kontakt?', {
        confirmButtonText: 'Da',
        cancelButtonText: 'Prekliči',
        confirmButtonClass: 'gumb-potrdi',
        cancelButtonClass: 'gumb-preklici',
        customClass: 'opozorilo-dialog'
      }).then(() => {
        this.OdstraniPrejemnikaIzSeznama(contact)
      }).catch(() => {

      })
    },
    UpdateIzbranPosiljatelj () {
      this.posiljateljObjekt = this.PoisciPosiljateljaPrekoMsisdn(this.posiljateljMsisdn)
      if (typeof this.posiljateljObjekt !== 'undefined') {
        this.$emit('updateIzbranPosiljatelj', JSON.parse(JSON.stringify(this.posiljateljObjekt)))
      }
    },
    PoisciPosiljateljaPrekoMsisdn (stevilka) {
      for (let i = 0; i < this.listaPosiljatelji.length; i++) {
        if (this.listaPosiljatelji[i].telefonska_stevilka === stevilka) {
          return this.listaPosiljatelji[i]
        }
      }
    },
    OdstraniPrejemnikaIzSeznama (contact) {
      for (let i = 0; i < this.selectedContacts.length; i++) {
        if (this.selectedContacts[i] === contact) {
          let index = this.selectedContacts.indexOf(contact)
          this.selectedContacts.splice(index, 1)
          this.$emit('updateSelectedContacts', this.selectedContacts)
          break
        }
      }
    },
    PreveriDodajPrejemnikaStevilka () {
      if (!this.smsAuthentication) {
        this.$emit('mfaIzklopljen')
      } else if (this.selectedContacts.length < this.smsLimit) {
        let regex = new RegExp('^[0-9]{6}')
        let regex2 = new RegExp('^(\\d)\\1*$')
        let celaSt = this.zacetnaStDodajPrejemnika.concat(this.drugiDelStDodajPrejemnika)
        let telZeObstaja = false
        for (let stevilka in this.selectedContacts) {
          if (this.selectedContacts[stevilka].mobile === celaSt) {
            telZeObstaja = true
            let paramObvestilo = {}
            paramObvestilo.message = 'Številka je že dodana na seznam za prejemnikov.'
            this.ShowWarningMessage(paramObvestilo)
            return false
          }
        }
        if (this.drugiDelStDodajPrejemnika !== null &&
          this.drugiDelStDodajPrejemnika.length === 6 &&
          regex.test(this.drugiDelStDodajPrejemnika) === true &&
          regex2.test(this.drugiDelStDodajPrejemnika) === false &&
          telZeObstaja === false) {
          for (let i = 0; i < this.vsiKontakti.length; i++) {
            if (this.vsiKontakti[i].mobile === celaSt) {
              this.selectedContacts.push(this.vsiKontakti[i])
              this.$emit('updateSelectedContacts', this.selectedContacts)
              this.drugiDelStDodajPrejemnika = ''
              return true
            }
          }
          this.selectedContacts.push({mobile: celaSt})
          this.$emit('updateSelectedContacts', this.selectedContacts)
          this.drugiDelStDodajPrejemnika = ''
        } else {
          let paramObvestilo = {}
          paramObvestilo.message = 'Vpisana številka ni pravilnega formata!'
          this.ShowWarningMessage(paramObvestilo)
        }
      } else {
        let paramObvestilo = {}
        paramObvestilo.message = 'Na seznamu prejemnikov je lahko največ ' + this.smsLimit + ' kontaktov.'
        this.ShowWarningMessage(paramObvestilo)
      }
    },
    PosljiSporocilo () {
      if (!this.smsAuthentication) {
        this.$emit('mfaIzklopljen')
      } else {
        if (this.selectedContacts.length === 0) {
          let paramObvestilo = {}
          paramObvestilo.message = 'Dodajte prejemnike sporočila.'
          this.ShowWarningMessage(paramObvestilo)
          return false
        }
        if (this.posiljateljObjekt === null) {
          let paramObvestilo = {}
          paramObvestilo.message = 'Izberite pošiljatelja sporočila.'
          this.ShowWarningMessage(paramObvestilo)
          return false
        }
        if (this.vnesenTextSmsa.length === 0) {
          let paramObvestilo = {}
          paramObvestilo.message = 'Vpišite vsebino sporočila.'
          this.ShowWarningMessage(paramObvestilo)
          return false
        }
        let param = ['posiljatelj=' + this.izbranPosiljatelj.telefonska_stevilka]
        param.push('vsebina=' + this.vnesenTextSmsa)
        for (let i = 0; i < this.selectedContacts.length; i++) {
          if (this.selectedContacts[i].mobile.charAt(0) === '0') {
            param.push('prejemniki[]=386' + this.selectedContacts[i].mobile.substr(1))
          } else {
            param.push('prejemniki[]=' + this.selectedContacts[i].mobile)
          }
        }
        let errorMessage = 'Napaka pri pošiljanju SMS sporočila'
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/sms/poslji?',
          param,
          errorMessage,
          'ShowSuccessSentMessage',
          'SendErrorMsg')
      }
    },
    ShowSuccessSentMessage () {
      this.$emit('updateSelectedContacts', [])
      this.vnesenTextSmsa = ''
      this.SendSuccessMsg('Sporočilo uspešno poslano izbranim kontaktom')
    },
    SendErrorMsg (errorMessage) {
      this.ShowWarningMessage(errorMessage)
    },
    SendSuccessMsg (successMessage) {
      this.ShowSuccessMessage(successMessage)
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/UporabniskiKoticek/PosljiSms/PosljiSmsVmesnik.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/UporabniskiKoticek/PosljiSms/PosljiSmsVmesnik.vue